import script from "./PictureOpen.vue?vue&type=script&setup=true&lang=js"
export * from "./PictureOpen.vue?vue&type=script&setup=true&lang=js"

import "./PictureOpen.vue?vue&type=style&index=0&id=88dcc502&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88dcc502"]])

export default __exports__